// Guest model
import { signal } from "@preact/signals-react";

import { useStore } from "storev2/formStore";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import { layout as folioLayout } from "./folio";
import { UserIcon } from "components/Icons";
import CardGuest from "./CardGuest";

const GUEST = [
  { id: "adult", name: "adult" },
  { id: "child", name: "child" },
];

const SEX = [
  { id: "female", name: "female" },
  { id: "male", name: "male" },
];

const TYPES = [
  { id: "13", name: "Cédula Ciudadania" },
  { id: "41", name: "Pasaporte" },
  { id: "12", name: "Tarjeta Identidad" },
  { id: "11", name: "Registro Civil" },
  { id: "21", name: "Tarjeta Extranjeria" },
  { id: "22", name: "Cedula Extranjeria" },
  { id: "42", name: "Tipo Documento Extranjero" },
  { id: "47", name: "PEP" },
  { id: "91", name: "NUIP" },
];

const fields = [
  "name",
  "id_number",
  "type_document",
  "sex",
  "main_mobile",
  "main_email",
  "street",
  "birthday",
  "nationality.rec_name",
  "country.rec_name",
];

function getRequiredByMainGuest(record) {
  return record.main_guest ? true : false;
}

function onChangeNationality(record) {
  if (record.nationality) {
    record.origin_country = record.nationality;
    record.target_country = record.nationality;
  }
  return record;
}

async function onAutoCreateGuest(active, store) {
  const { updateRecord } = useStore.getState();

  const domain = [
    ["lines", "=", store.folio],
    ["party.type_document", "!=", "31"],
  ];
  const { data: bookings } = await proxy.search("hotel.booking", domain, [
    "party.name",
    "party.id_number",
    "party.street",
    "party.main_mobile",
    "party.main_email",
    "party.birthday",
    "party.type_document",
    "party.sex",
    "party.country.name",
    "party.nationality.name",
  ]);

  if (bookings.length === 0) return;
  const party = bookings[0]["party."];
  if (!party.id) {
    return {
      msg: "hotel.guest.you_can_not_clone_holder",
    };
  }
  const defaulTypeGuest = { id: "adult", name: "Adulto" };
  const guest = {
    name: party.name,
    id_number: party.id_number,
    main_guest: true,
    address: party.street,
    mobile: party.main_mobile,
    email: party.main_email,
    birthday: party.birthday,
    folio: store.folio,
  };

  const storeGuest = { ...guest };
  const activeGuest = { ...guest };
  storeGuest.type_guest = "adult";
  activeGuest.type_guest = defaulTypeGuest;
  if (party.type_document) {
    for (const _type of TYPES) {
      if (_type.id === party.type_document) {
        activeGuest.type_document = _type;
        storeGuest.type_document = _type.id;
      }
    }
  }
  if (party["country."]) {
    activeGuest.country = party["country."];
    storeGuest.country = party["country."].id;
  }
  if (party["nationality."]) {
    activeGuest.nationality = party["nationality."];
    storeGuest.nationality = party["nationality."].id;
  }

  if (party.sex) {
    for (const _sex of SEX) {
      if (_sex.id === party.sex) {
        activeGuest.sex = _sex;
        storeGuest.sex = _sex.id;
      }
    }
  }

  const activeUp = { ...active, ...activeGuest };
  const storeUp = { ...store, ...storeGuest };
  updateRecord(activeUp, storeUp, "hotel.folio.guest", active.id);
}

function visibleCreateGuest() {
  return true;
}

function visibleForeingCity(storeRec) {
  const config = getStorage("hotelConfig");
  const country = config["nationality."]?.id;
  const res = storeRec.nationality?.id === country;
  return !res;
}

async function onCreate(parentRec) {
  const { setRecord } = useStore.getState();
  const folioLay = folioLayout();
  const { record: folio } = parentRec;
  const model = "hotel.folio";
  const values = {
    model: model,
    method: "set_persons",
    args: [folio.id],
  };
  const { data } = await proxy.methodCall(values);
  setRecord(folio.id, model, folioLay);
}

function getDefaultCountry() {
  const config = getStorage("hotelConfig");
  return config?.["nationality."];
}

async function onChangeIdNumber(record, store) {
  if (record.id_number) {
    const fieldsNames = [
      "name",
      "email",
      "mobile",
      "birthday",
      "profession",
      "type_document",
      "sex",
      "nationality.name",
      "nationality.code",
      "origin_country.name",
      "origin_country.code",
      "target_country.name",
      "target_country.code",
      "address",
    ];
    const { data } = await proxy.search(
      "hotel.folio.guest",
      [["id_number", "=", record.id_number]],
      fieldsNames,
    );
    if (data && data.length > 0) {
      const guest = data.pop();
      delete guest.id;

      fieldsNames.forEach((field) => {
        if (field === "sex") {
          for (const _sex of SEX) {
            if (_sex.id === guest.sex) {
              record.sex = _sex;
              store.sex = _sex.id;
            }
          }
        } else if (field === "type_document") {
          for (const _type of TYPES) {
            if (_type.id === guest.sex) {
              record.sex = _type;
              store.sex = _type.id;
            }
          }
        } else if (guest[field]) {
          record[field] = guest[field];
          store[field] = guest[field];
        } else if (guest[field + "."]) {
          record[field] = guest[field + "."];
          store[field] = guest[field + "."];
        }
      });
    }
  }
  return (record, store);
}

function layout() {
  const ctxView = {
    model: "hotel.folio.guest",
    form_action: ["add", "delete", "edit"],
    table_action: ["add", "edit"],
    card_action: ["add"],
    orderBy: [["name", "ASC"]],
    selectable: null, // Options for table rows: null, multi, one
    target: "folio",
    Card: CardGuest,
    defaultView: "cards",
    triggerCreate: onCreate,
    fields: {
      name: { type: "char", required: true },
      type_guest: {
        type: "selection",
        options: GUEST,
        required: true,
        default: { id: "adult", name: "Adulto" },
      },
      type_document: {
        type: "selection",
        options: TYPES,
        required: true,
        default: { id: "13", name: "Cédula Ciudadania" },
      },
      sex: {
        type: "selection",
        options: SEX,
        required: true,
        default: { id: "male", name: "male" },
      },
      id_number: { type: "char", required: true, withChange: onChangeIdNumber },
      mobile: {
        type: "char",
        required: signal(),
        getRequired: getRequiredByMainGuest,
      },
      email: {
        type: "char",
        required: signal(),
        getRequired: getRequiredByMainGuest,
      },
      address: {
        type: "char",
        required: signal(),
        getRequired: getRequiredByMainGuest,
      },
      birthday: { type: "date", required: true },
      profession: { type: "char" },
      notes: { type: "text" },
      foreign_city: { type: "char" },
      main_guest: {
        type: "boolean",
        dependents: ["email", "mobile", "address"],
      },
      nationality: {
        type: "many2one",
        model: "country.country",
        default: getDefaultCountry,
        required: true,
        dependents: ["origin_country", "target_country", "code"],
        withChange: onChangeNationality,
      },
      origin_country: {
        type: "many2one",
        model: "country.country",
        default: getDefaultCountry,
        required: true,
      },
      target_country: {
        type: "many2one",
        default: getDefaultCountry,
        model: "country.country",
        required: true,
      },
      clone_holder: {
        type: "button",
        visible: visibleCreateGuest,
        color: "amber",
        method: onAutoCreateGuest,
        iconLeft: <UserIcon className="h-5 w-5 fill-current" />,
      },
    },
    list: [
      { name: "name", width: "25%" },
      { name: "type_guest", width: "15%" },
      { name: "type_document", width: "10%" },
      { name: "id_number", width: "10%" },
      { name: "mobile", width: "10%" },
      { name: "main_guest", width: "5%" },
      { name: "birthday", width: "5%" },
      { name: "nationality", width: "5%" },
      { name: "sex", width: "5%" },
    ],
    form: [
      { name: "id_number" },
      { name: "clone_holder" },
      { name: "type_guest" },
      { name: "main_guest" },
      { name: "type_document" },
      { name: "name" },
      {
        name: "info",
        type: "grid",
        elements: [{ name: "birthday" }, { name: "sex" }],
        colSpan: "col-span-1",
      },
      { name: "nationality" },
      { name: "foreign_city" },
      {
        name: "info_country",
        type: "grid",
        elements: [{ name: "origin_country" }, { name: "target_country" }],
        colSpan: "col-span-1",
      },
      { name: "mobile" },
      { name: "address" },
      { name: "email" },
      { name: "notes" },
    ],
    card: CardGuest,
  };

  return ctxView;
}

export { layout };
